import { SectionProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { PolicyAdjustmentResponse } from '../../../../domain'
import { usePaymentSchedule } from '../../../product/paymentScheduleContext'
import { MonthlyPremiumSection } from './components/MonthlyPremiumSection'
import { SinglePaymentPremiumSection } from './components/SinglePaymentPremiumSection'

export interface ProrataPremiumSectionProps extends SectionProps {
  adjustment: PolicyAdjustmentResponse
}

export const ProrataPremiumSection: FunctionComponent<ProrataPremiumSectionProps> = ({
  adjustment,
  ...props
}) => {
  const { paymentScheduleType } = usePaymentSchedule()

  switch (paymentScheduleType) {
    case 'MONTHLY':
      return <MonthlyPremiumSection adjustment={adjustment} {...props} />
    case 'SINGLE_PAYMENT':
      return <SinglePaymentPremiumSection adjustment={adjustment} {...props} />
  }
}
